export default __webpack_public_path__ + "static/media/sallab.e80f2f94.jpg";